
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("8j9VY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0822a3785a204258$export$2e2bcd8739ae039);


var $hF7dB = parcelRequire("hF7dB");

var $9uTsJ = parcelRequire("9uTsJ");
var $0822a3785a204258$export$2e2bcd8739ae039 = (0, $9uTsJ.default);

});
parcelRegister("hF7dB", function(module, exports) {

$parcel$export(module.exports, "ProfileCardLazy", () => $14151ca210c57240$export$403d297463f226af);

var $gwFzn = parcelRequire("gwFzn");

const $14151ca210c57240$export$403d297463f226af = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("bYH2E")));

});
parcelRegister("bYH2E", function(module, exports) {

let $02401b9adb16af75$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $02401b9adb16af75$var$load("ekztv"),
    $02401b9adb16af75$var$load("dUEf9"),
    $02401b9adb16af75$var$load("lvR1M"),
    $02401b9adb16af75$var$load("kUAIU"),
    $02401b9adb16af75$var$load("4fCJZ"),
    $02401b9adb16af75$var$load("dTsOE"),
    $02401b9adb16af75$var$load("6zfzy"),
    $02401b9adb16af75$var$load("kSjKH")
]).then(()=>parcelRequire('f12Eo'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});




parcelRegister("9uTsJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5942c2aa812a2515$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $iK7QL = parcelRequire("iK7QL");
var $9EUfN = parcelRequire("9EUfN");

var $dh538 = parcelRequire("dh538");

var $lGgRw = parcelRequire("lGgRw");

var $dTk3A = parcelRequire("dTk3A");

var $81aSu = parcelRequire("81aSu");

var $9MfJy = parcelRequire("9MfJy");

var $85wtj = parcelRequire("85wtj");

var $bUp2E = parcelRequire("bUp2E");

var $fVnHQ = parcelRequire("fVnHQ");

var $3nj6t = parcelRequire("3nj6t");

var $hF7dB = parcelRequire("hF7dB");

var $j96Dd = parcelRequire("j96Dd");
function $5942c2aa812a2515$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
    if (isAgent) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3nj6t.AgentProfileCardResourced), {
        accountId: userId,
        cloudId: cloudId,
        resourceClient: resourceClient,
        viewingUserId: viewingUserId,
        trigger: trigger,
        product: product,
        onChatClick: agentActions?.onChatClick,
        onConversationStartersClick: agentActions?.onConversationStartersClick,
        addFlag: addFlag
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hF7dB.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        })
    });
}
function $5942c2aa812a2515$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions, ariaHideProfileTrigger: ariaHideProfileTrigger = false, isVisible: propsIsVisible }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isMounted = (0, $gwFzn.useRef)(false);
    const showDelay = trigger === 'click' || propsIsVisible && (0, $dh538.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $fVnHQ.DELAY_MS_SHOW);
    const hideDelay = trigger === 'click' || propsIsVisible && (0, $dh538.fg)('fix_profilecard_trigger_isvisible') ? 0 : (0, $fVnHQ.DELAY_MS_HIDE);
    const showTimer = (0, $gwFzn.useRef)(0);
    const hideTimer = (0, $gwFzn.useRef)(0);
    const [visible, setVisible] = (0, $gwFzn.useState)(false);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(undefined);
    const [hasError, setHasError] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)(null);
    const [data, setData] = (0, $gwFzn.useState)(null);
    const [reportingLinesData, setReportingLinesData] = (0, $gwFzn.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $gwFzn.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $gwFzn.useState)(undefined);
    const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $gwFzn.useState)(false);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $gwFzn.useState)(false);
    const triggerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
        };
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        // Reset state when the userId changes
        setIsLoading(undefined);
        setHasError(false);
        setError(null);
        setData(null);
        setReportingLinesData(undefined);
        setShouldShowGiveKudos(false);
        setTeamCentralBaseUrl(undefined);
    }, [
        userId
    ]);
    const fireAnalytics = (0, $gwFzn.useCallback)((payload)=>{
        // Don't fire any analytics if the component is unmounted
        if (!isMounted.current) return;
        (0, $bUp2E.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const hideProfilecard = (0, $gwFzn.useCallback)(()=>{
        clearTimeout(showTimer.current);
        clearTimeout(hideTimer.current);
        if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, hideDelay);
    }, [
        hideDelay,
        isTriggeredUsingKeyboard,
        onVisibilityChange
    ]);
    const handleKeyboardClose = (0, $gwFzn.useCallback)((event)=>{
        if (event.key && event.key !== 'Escape') return;
        if (triggerRef.current) triggerRef.current.focus();
        setTriggeredUsingKeyboard(false);
        setVisible(false);
        onVisibilityChange && onVisibilityChange(false);
    }, [
        setTriggeredUsingKeyboard,
        setVisible,
        onVisibilityChange
    ]);
    const handleClientSuccess = (0, $gwFzn.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(false);
        setData(profileData);
        setReportingLinesData(reportingLinesData);
        setTeamCentralBaseUrl(teamCentralBaseUrl);
        setShouldShowGiveKudos(shouldShowGiveKudos);
    }, [
        setHasError,
        setIsLoading,
        setData,
        setReportingLinesData,
        setShouldShowGiveKudos
    ]);
    const handleClientError = (0, $gwFzn.useCallback)((err)=>{
        if (!isMounted.current) return;
        setIsLoading(false);
        setHasError(true);
        setError(err);
    }, [
        setHasError,
        setIsLoading,
        setError
    ]);
    const clientFetchProfile = (0, $gwFzn.useCallback)(async ()=>{
        if (isLoading === true) // don't fetch data when fetching is in process
        return;
        setIsLoading(true);
        setHasError(false);
        setError(null);
        setData(null);
        try {
            const requests = Promise.all([
                resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                resourceClient.getReportingLines(userId),
                resourceClient.shouldShowGiveKudos(),
                resourceClient.getTeamCentralBaseUrl({
                    withOrgContext: true,
                    withSiteContext: true
                })
            ]);
            const responses = await requests;
            handleClientSuccess(...responses);
        } catch (err) {
            handleClientError(err);
        }
    }, [
        cloudId,
        fireAnalytics,
        isLoading,
        resourceClient,
        userId,
        handleClientSuccess,
        handleClientError
    ]);
    const showProfilecard = (0, $gwFzn.useCallback)(()=>{
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(()=>{
            if (!visible) {
                clientFetchProfile();
                setVisible(true);
                onVisibilityChange && onVisibilityChange(true);
            }
        }, showDelay);
    }, [
        showDelay,
        visible,
        clientFetchProfile,
        onVisibilityChange
    ]);
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        // If the user clicks on the trigger then we don't want that click event to
        // propagate out to parent containers. For example when clicking a mention
        // lozenge in an inline-edit.
        event.stopPropagation();
        showProfilecard();
        if (!visible) fireAnalytics((0, $bUp2E.cardTriggered)('user', 'click'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onMouseEnter = (0, $gwFzn.useCallback)(()=>{
        showProfilecard();
        if (!visible) fireAnalytics((0, $bUp2E.cardTriggered)('user', 'hover'));
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onKeyPress = (0, $gwFzn.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setTriggeredUsingKeyboard(true);
            showProfilecard();
            if (!visible) fireAnalytics((0, $bUp2E.cardTriggered)('user', 'click'));
        }
    }, [
        fireAnalytics,
        showProfilecard,
        visible
    ]);
    const onFocus = (0, $gwFzn.useCallback)(()=>{
        showProfilecard();
    }, [
        showProfilecard
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!(0, $dh538.fg)('fix_profilecard_trigger_isvisible')) return;
        // If the prop isVisible is not defined, we don't want to do anything
        if (propsIsVisible === undefined) return;
        // If the prop isVisible is defined, we want to show or hide the profile card based on the value
        if (propsIsVisible) showProfilecard();
        else hideProfilecard();
    }, [
        hideProfilecard,
        propsIsVisible,
        showProfilecard
    ]);
    const containerListeners = (0, $gwFzn.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onBlur: hideProfilecard,
            onKeyPress: onKeyPress
        } : {
            onClick: onClick,
            onKeyPress: onKeyPress
        }, [
        hideProfilecard,
        onClick,
        onKeyPress,
        onMouseEnter,
        trigger
    ]);
    const filterActions = (0, $gwFzn.useCallback)(()=>{
        return (0, $81aSu.default)(actions, data);
    }, [
        actions,
        data
    ]);
    const openKudosDrawer = ()=>{
        hideProfilecard();
        setKudosDrawerOpen(true);
    };
    const closeKudosDrawer = ()=>{
        setKudosDrawerOpen(false);
    };
    const showLoading = isLoading === true || isLoading === undefined;
    const wrapperProps = (0, $gwFzn.useMemo)(()=>trigger === 'hover' ? {
            onMouseEnter: onMouseEnter,
            onMouseLeave: hideProfilecard,
            onFocus: onFocus
        } : {}, [
        hideProfilecard,
        onFocus,
        onMouseEnter,
        trigger
    ]);
    const profilecardProps = {
        userId: userId,
        fullName: prepopulatedData?.fullName,
        isCurrentUser: userId === viewingUserId,
        clientFetchProfile: clientFetchProfile,
        ...data,
        reportingLines: reportingLinesData,
        onReportingLinesClick: onReportingLinesClick,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        cloudId: cloudId,
        openKudosDrawer: openKudosDrawer,
        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
        disabledAriaAttributes: disabledAriaAttributes
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
                isOpen: !!visible,
                onClose: (event)=>{
                    hideProfilecard();
                    handleKeyboardClose(event);
                },
                placement: position,
                offset: offset ?? [
                    0,
                    8
                ],
                content: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        ...wrapperProps,
                        children: showLoading ? /*#__PURE__*/ (0, $7UHDa.jsx)($5942c2aa812a2515$var$LoadingView, {
                            fireAnalytics: fireAnalytics
                        }) : visible && /*#__PURE__*/ (0, $7UHDa.jsx)($5942c2aa812a2515$var$ProfileCardContent, {
                            profilecardProps: profilecardProps,
                            isAgent: !!data?.isAgent,
                            userId: userId,
                            cloudId: cloudId,
                            resourceClient: resourceClient,
                            viewingUserId: viewingUserId,
                            trigger: trigger,
                            product: product,
                            profileCardAction: filterActions(),
                            errorType: error,
                            hasError: hasError,
                            agentActions: agentActions,
                            addFlag: addFlag
                        })
                    }),
                trigger: (triggerProps)=>{
                    const { ref: callbackRef, ...innerProps } = triggerProps;
                    const ref = (element)=>{
                        triggerRef.current = element;
                        if (typeof callbackRef === 'function') callbackRef(element);
                    };
                    const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        ...disabledAriaAttributes ? restInnerProps : triggerProps,
                        ...containerListeners,
                        ref: ref,
                        "data-testid": testId,
                        ...!ariaHideProfileTrigger && {
                            'aria-labelledby': ariaLabelledBy
                        },
                        ...disabledAriaAttributes ? {} : {
                            role: 'button',
                            //  aria-hidden cannot contain focusable elements: https://dequeuniversity.com/rules/axe/3.5/aria-hidden-focus
                            tabIndex: ariaHideProfileTrigger ? -1 : 0,
                            'aria-label': ariaHideProfileTrigger ? undefined : (0, $9MfJy.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                        },
                        ...ariaHideProfileTrigger && {
                            'aria-hidden': 'true'
                        },
                        children: children
                    });
                },
                zIndex: (0, $dTk3A.layers).modal(),
                shouldUseCaptureOnOutsideClick: true,
                autoFocus: autoFocus ?? trigger === 'click',
                // This feature gate is currently enabled only for Jira_Web to avoid UI issues in Confluence_Web.
                shouldRenderToParent: (0, $dh538.fg)('enable_appropriate_reading_order_in_profile_card')
            }),
            shouldShowGiveKudos && teamCentralBaseUrl && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iK7QL.GiveKudosLauncherLazy), {
                    isOpen: kudosDrawerOpen,
                    recipient: {
                        type: (0, $9EUfN.KudosType).INDIVIDUAL,
                        recipientId: userId
                    },
                    analyticsSource: "profile-card",
                    teamCentralBaseUrl: teamCentralBaseUrl,
                    cloudId: cloudId,
                    addFlag: addFlag,
                    onClose: closeKudosDrawer
                })
            })
        ]
    });
}
const $5942c2aa812a2515$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $85wtj.CardWrapper), {
        testId: "profilecard.profilecardtrigger.loading",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j96Dd.default), {
            fireAnalytics: fireAnalytics
        })
    });

});
parcelRegister("iK7QL", function(module, exports) {

$parcel$export(module.exports, "GiveKudosLauncherLazy", () => $f28ce8dc3985e647$export$93fe397a02fe8b76);

var $gwFzn = parcelRequire("gwFzn");

const $f28ce8dc3985e647$export$93fe397a02fe8b76 = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("f63ln")));

});
parcelRegister("f63ln", function(module, exports) {

let $afda028e8be363c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $afda028e8be363c5$var$load("hGXAt"),
    $afda028e8be363c5$var$load("1Y6tF")
]).then(()=>parcelRequire('b3HrA'));

});


parcelRegister("9EUfN", function(module, exports) {

$parcel$export(module.exports, "KudosType", () => $6a667c4b16202b21$export$4fa2020056771264);
$parcel$export(module.exports, "FlagEventType", () => $6a667c4b16202b21$export$d21f9befaa2961a);
$parcel$export(module.exports, "isFlagEventTypeValue", () => $6a667c4b16202b21$export$7a1fc1a1b0477464);
var $6a667c4b16202b21$export$4fa2020056771264 = /*#__PURE__*/ function(KudosType) {
    KudosType["INDIVIDUAL"] = "individual";
    KudosType["TEAM"] = "team";
    KudosType["MIXED"] = "mixed";
    return KudosType;
}({});
var $6a667c4b16202b21$export$d21f9befaa2961a = /*#__PURE__*/ function(FlagEventType) {
    FlagEventType["KUDOS_CREATED"] = "kudos-created";
    FlagEventType["KUDOS_FAILED"] = "kudos-failed";
    FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
    FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
    FlagEventType["DIRTY"] = "dirty";
    FlagEventType["CLOSE"] = "close";
    return FlagEventType;
}({});
const $6a667c4b16202b21$export$7a1fc1a1b0477464 = (value)=>{
    return Object.values($6a667c4b16202b21$export$d21f9befaa2961a).includes(value);
};

});

parcelRegister("81aSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d60d4b660fa77e33$export$2e2bcd8739ae039);
const $d60d4b660fa77e33$var$filterActions = (actions = [], data)=>{
    return actions.filter((action)=>{
        if (!action.shouldRender) return true;
        else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
        return action.shouldRender(data);
    });
};
var $d60d4b660fa77e33$export$2e2bcd8739ae039 = $d60d4b660fa77e33$var$filterActions;

});

parcelRegister("9MfJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $201409dad5c676c1$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
const $201409dad5c676c1$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
    if (ariaLabelProp) return ariaLabelProp;
    return fullName ? formatMessage($201409dad5c676c1$var$messages.label, {
        fullName: fullName
    }) : formatMessage($201409dad5c676c1$var$messages.fallbackLabel);
};
const $201409dad5c676c1$var$messages = (0, $2nPZH.defineMessages)({
    fallbackLabel: {
        id: "profilecard.user.trigger.fallback-aria-label",
        defaultMessage: "More information about this user"
    },
    label: {
        id: "profilecard.user.trigger.aria-label",
        defaultMessage: "More information about {fullName}"
    }
});
var $201409dad5c676c1$export$2e2bcd8739ae039 = $201409dad5c676c1$var$getLabelMessage;

});

parcelRegister("85wtj", function(module, exports) {

$parcel$export(module.exports, "CardWrapper", () => $ea4adcbc87a38cf2$export$6aa22a823032b784);
$parcel$export(module.exports, "ProfileImage", () => $ea4adcbc87a38cf2$export$a7a74ab5cffd1455);
$parcel$export(module.exports, "ActionsFlexSpacer", () => $ea4adcbc87a38cf2$export$d395c8d16f1e359d);
$parcel$export(module.exports, "KudosBlobAnimation", () => $ea4adcbc87a38cf2$export$4a8a956251d4bf6f);
$parcel$export(module.exports, "AnimationWrapper", () => $ea4adcbc87a38cf2$export$58517bb1b373a54c);
$parcel$export(module.exports, "AnimatedKudosButton", () => $ea4adcbc87a38cf2$export$6196a3f52a6944fe);
$parcel$export(module.exports, "ActionButtonGroup", () => $ea4adcbc87a38cf2$export$73d695ae27330056);
$parcel$export(module.exports, "OverflowActionButtonsWrapper", () => $ea4adcbc87a38cf2$export$ff778e5b796745a6);
$parcel$export(module.exports, "CardContent", () => $ea4adcbc87a38cf2$export$64ef9b8c11710c47);
$parcel$export(module.exports, "DetailsGroup", () => $ea4adcbc87a38cf2$export$35cf684daac137ac);
$parcel$export(module.exports, "DisabledInfo", () => $ea4adcbc87a38cf2$export$2062e7265a95a823);
$parcel$export(module.exports, "LozengeWrapper", () => $ea4adcbc87a38cf2$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "CustomLozengeContainer", () => $ea4adcbc87a38cf2$export$6ebf103500ba5a45);
$parcel$export(module.exports, "JobTitleLabel", () => $ea4adcbc87a38cf2$export$d6c0e5f211c8d617);
$parcel$export(module.exports, "AppTitleLabel", () => $ea4adcbc87a38cf2$export$4865ffa72a4d5f9);
$parcel$export(module.exports, "SpinnerContainer", () => $ea4adcbc87a38cf2$export$a5e06607a5ac6158);
$parcel$export(module.exports, "CardContainer", () => $ea4adcbc87a38cf2$export$8a23e74e5cf3ca41);
$parcel$export(module.exports, "DetailsLabel", () => $ea4adcbc87a38cf2$export$138a08882ebf7289);
$parcel$export(module.exports, "DetailsLabelIcon", () => $ea4adcbc87a38cf2$export$79d7d9b2f6a70c70);
$parcel$export(module.exports, "DetailsLabelText", () => $ea4adcbc87a38cf2$export$b0ec2c767a0e0eab);
/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $1Whri = parcelRequire("1Whri");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $iXCQx = parcelRequire("iXCQx");

var $dTk3A = parcelRequire("dTk3A");

var $aCAiO = parcelRequire("aCAiO");

var $gwrgp = parcelRequire("gwrgp");
const $ea4adcbc87a38cf2$var$kudosButtonAnimationTransformationCompiled = null;
const $ea4adcbc87a38cf2$var$styles = {
    cardWrapper: "_2rkoglpi _1bsb1gwv",
    profileImage: "_kqswstnw _154i1ejb _1ltv1ejb",
    actionsFlexSpacer: "_16jlkb7n _1o9zidpf _i0dl1wug",
    kudosBlobAnimationStyle: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _154ixy5q",
    animationWrapper: "_mkrz1rip _kqswstnw _154ize3t _1ltvze3t _94n5ze3t _1xi2ze3t",
    animatedKudosButton: "_18u0u2gc",
    actionButtonGroup: "_zulp12x7 _uiztglyw _19pkpxbi _2hwxze3t _18u0ze3t _otyrze3t _y3gnusic _1bahesu3 _1e0c1txw",
    overflowActionButtonsWrapper: "_1e0c1o8l _1bsbzwfg _4t3izwfg",
    cardContent: "_1e0c1txw _2lx21bp4 _1tkebv7e",
    detailsGroup: "_1e0c1txw _2lx21bp4 _18u01epz _19bvxy5q _1bsb18pt",
    disabledInfo: "_11c81o8v _syaz1fxt _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t",
    lozengeWrapper: "_19pkpxbi _1e0c1ule",
    customLozengeContainer: "_1e0c1txw _2lx2vrvc _1n261g80 _1bah1y6m _19pkutpp",
    spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm",
    cardContainer: "_1reo15vq _18m915vq _kqswh2mm _12vemgnk _1lrw14bs _ca0q1ejb _19bv1ejb _u5f31ejb _n3td1ejb",
    cardContainerActiveUser: "_1itk1419",
    cardContainerDisabledUser: "_1itkkf3t",
    cardContainerWithElevation: "_2rkoglpi _16qs1cd0",
    detailsLabel: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _19pkutpp _2hwxze3t _18u0ze3t _otyrze3t _o5721q9c",
    detailsLabelExtraTopSpace: "_19pkxy5q",
    detailsLabelIcon: "_1e0c1txw _1o9zidpf _syaz131l _1bsb7vkz _4t3i7vkz _s7n4jp4b _19pkze3t",
    detailsLabelText: "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _syaz1fxt _19pkze3t _18u0ze3t",
    kudosBlobAnimation: "_1e0cglyw _4t3i1w81 _1bsb1w81 _1pby1mrw _kqswstnw _j7hq1q51 _tip8kb7n _5sagi11n _1itkiwwe",
    jobTitleLabel: "_19pkze3t _otyrze3t _18u0utpp _2hwxze3t",
    appTitleLabel: "_2rkoglpi _syaz1fxt _u5f312x7 _19bv12x7 _1bsb1ns9 _19pk1b66 _otyrze3t _18u0utpp _2hwxze3t"
};
const $ea4adcbc87a38cf2$export$6aa22a823032b784 = ({ children: children, role: role, testId: testId, labelledBy: labelledBy })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.cardWrapper),
        backgroundColor: 'elevation.surface.overlay',
        role: role,
        testId: testId,
        "aria-labelledby": labelledBy,
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$CardWrapperLegacy, {
        "data-testid": testId,
        role: role,
        "aria-labelledby": labelledBy,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$CardWrapperLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo0"
})("background-color:", (0, $aCAiO.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:360px;");
const $ea4adcbc87a38cf2$export$a7a74ab5cffd1455 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.profileImage),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$ProfileImageLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$ProfileImageLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo1"
})({
    name: "1su61qk",
    styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px);"
});
const $ea4adcbc87a38cf2$export$d395c8d16f1e359d = ()=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.actionsFlexSpacer)
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$ActionsFlexSpacerLegacy, {}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$ActionsFlexSpacerLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo2"
})({
    name: "1c3h18e",
    styles: "flex:1 0 auto;"
}); // eslint-disable-next-line @atlaskit/design-system/no-keyframes-tagged-template-expression -- needs manual remediation
const $ea4adcbc87a38cf2$var$kudosButtonAnimationTransformation = (0, $3jLHL.keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
const $ea4adcbc87a38cf2$export$b08abf2f97b92ea5 = ()=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.kudosBlobAnimationStyle)
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$KudosBlobAnimationStyleLegacy, {
        className: "kudos-blob-animation"
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ea4adcbc87a38cf2$var$KudosBlobAnimationStyleLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo3"
})("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", 32 / 14, "em;animation-name:", $ea4adcbc87a38cf2$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient( circle,var(--ds-background-information-pressed, #85B8FF) 0%,var(--ds-background-discovery-pressed, #B8ACF6) 25%,transparent 50% );overflow:hidden;");
const $ea4adcbc87a38cf2$export$4a8a956251d4bf6f = ()=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.kudosBlobAnimationStyle)
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$KudosBlobAnimationLegacy, {});
const $ea4adcbc87a38cf2$var$KudosBlobAnimationLegacy = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$export$b08abf2f97b92ea5, {});
const $ea4adcbc87a38cf2$export$58517bb1b373a54c = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.animationWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$AnimationWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$AnimationWrapperLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo4"
})("clip-path:inset(0px 0px 0px 0px round ", (0, $dTk3A.borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
const $ea4adcbc87a38cf2$export$6196a3f52a6944fe = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.animatedKudosButton),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$AnimatedKudosButtonLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$AnimatedKudosButtonLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo5"
})({
    name: "18xp5qc",
    styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
});
const $ea4adcbc87a38cf2$export$73d695ae27330056 = ({ children: children, testId: testId })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: testId,
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.actionButtonGroup),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$ActionButtonGroupLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$ActionButtonGroupLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo6"
})({
    name: "zpe4ea",
    styles: "user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:var(--ds-border-focused, #388BFF);outline-offset:var(--ds-border-width, 1px);outline-style:solid;outline-width:var(--ds-border-width, 1px);}}"
});
const $ea4adcbc87a38cf2$export$ff778e5b796745a6 = ({ children: children, testId: testId })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: testId,
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.overflowActionButtonsWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$OverflowActionButtonsWrapperLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$OverflowActionButtonsWrapperLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo7"
})({
    name: "1yvvdjx",
    styles: "display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:var(--ds-border-focused, #388BFF);outline-offset:var(--ds-border-width, 1px);outline-style:solid;outline-width:var(--ds-border-width, 1px);}}"
});
const $ea4adcbc87a38cf2$export$64ef9b8c11710c47 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.cardContent),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$CardContentLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$CardContentLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo8"
})({
    name: "1vfswt",
    styles: "display:flex;flex-direction:column;min-height:136px;"
});
const $ea4adcbc87a38cf2$export$35cf684daac137ac = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.detailsGroup),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$DetailsGroupLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$DetailsGroupLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo9"
})({
    name: "o0zt4g",
    styles: "display:flex;flex-direction:column;margin-left:116px;width:196px;"
});
const $ea4adcbc87a38cf2$export$2062e7265a95a823 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.disabledInfo),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$DisabledInfoLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$DisabledInfoLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo10"
})("font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $aCAiO.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
const $ea4adcbc87a38cf2$export$75180efdd3f4d9c2 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.lozengeWrapper),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$LozengeWrapperLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$LozengeWrapperLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo11"
})({
    name: "qa77ym",
    styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block;"
});
const $ea4adcbc87a38cf2$export$6ebf103500ba5a45 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.customLozengeContainer),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$CustomLozengeContainerLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$CustomLozengeContainerLegacy = /*#__PURE__*/ (0, $gwrgp.default)($ea4adcbc87a38cf2$export$75180efdd3f4d9c2, {
    target: "e1ebb2vo12"
})({
    name: "1logu7f",
    styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);> *{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
});
const $ea4adcbc87a38cf2$export$d6c0e5f211c8d617 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.jobTitleLabel),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            maxLines: 1,
            color: "color.text.inverse",
            children: children
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$JobTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$JobTitleLabelLegacy = (0, $gwrgp.default)("span", {
    target: "e1ebb2vo13"
})("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);color:", (0, $aCAiO.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;");
const $ea4adcbc87a38cf2$export$4865ffa72a4d5f9 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.appTitleLabel),
        backgroundColor: "color.background.neutral",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            color: "color.text",
            size: "UNSAFE_small",
            weight: "bold",
            children: children
        })
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$AppTitleLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$AppTitleLabelLegacy = (0, $gwrgp.default)("span", {
    target: "e1ebb2vo14"
})("background:", (0, $aCAiO.appLabelBgColor), ";color:", (0, $aCAiO.appLabelTextColor), ";border-radius:", (0, $dTk3A.borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:var(--ds-font-weight-bold, 700);text-transform:uppercase;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;");
const $ea4adcbc87a38cf2$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: testId,
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.spinnerContainer),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$SpinnerContainerLegacy, {
        "data-testid": testId,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$SpinnerContainerLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo15"
})({
    name: "zoz7g7",
    styles: "align-items:center;display:flex;height:96px;justify-content:center;position:relative;"
});
const $ea4adcbc87a38cf2$export$8a23e74e5cf3ca41 = ({ children: children, isDisabledUser: isDisabledUser, withoutElevation: withoutElevation })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.cardContainer, isDisabledUser ? $ea4adcbc87a38cf2$var$styles.cardContainerDisabledUser : $ea4adcbc87a38cf2$var$styles.cardContainerActiveUser, !withoutElevation && $ea4adcbc87a38cf2$var$styles.cardContainerWithElevation),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$CardContainerLegacy, {
        isDisabledUser: isDisabledUser,
        withoutElevation: withoutElevation,
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$CardContainerLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo16"
})("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient( to bottom,", (props)=>props.isDisabledUser ? (0, $aCAiO.headerBgColorDisabledUser) : (0, $aCAiO.headerBgColor), " 0%,", (props)=>props.isDisabledUser ? (0, $aCAiO.headerBgColorDisabledUser) : (0, $aCAiO.headerBgColor), " 100% );background-repeat:no-repeat;background-size:100% 96px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, $dTk3A.borderRadius)()}px`, ";overflow:hidden;");
const $ea4adcbc87a38cf2$export$138a08882ebf7289 = ({ children: children, extraTopSpace: extraTopSpace = false })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.detailsLabel, extraTopSpace && $ea4adcbc87a38cf2$var$styles.detailsLabelExtraTopSpace),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$DetailsLabelLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$DetailsLabelLegacy = (0, $gwrgp.default)("div", {
    target: "e1ebb2vo17"
})({
    name: "1uf2y6z",
    styles: "display:flex;align-items:center;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;& + &{margin-top:var(--ds-space-025, 2px);}"
});
const $ea4adcbc87a38cf2$export$79d7d9b2f6a70c70 = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "dt",
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.detailsLabelIcon),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$DetailsLabelIconLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$DetailsLabelIconLegacy = (0, $gwrgp.default)("dt", {
    target: "e1ebb2vo18"
})("display:flex;flex-shrink:0;color:", (0, $aCAiO.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
const $ea4adcbc87a38cf2$export$b0ec2c767a0e0eab = ({ children: children })=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        as: "dd",
        xcss: (0, $1Whri.cx)($ea4adcbc87a38cf2$var$styles.detailsLabelText),
        children: children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($ea4adcbc87a38cf2$var$DetailsLabelTextLegacy, {
        children: children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ea4adcbc87a38cf2$var$DetailsLabelTextLegacy = (0, $gwrgp.default)("dd", {
    target: "e1ebb2vo19"
})("overflow:hidden;text-overflow:ellipsis;color:", (0, $aCAiO.labelTextColor), ";font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-050, 4px);padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");

});
parcelRegister("aCAiO", function(module, exports) {

$parcel$export(module.exports, "bgColor", () => $20d409d918b45f60$export$7dcbec377a25efc6);
$parcel$export(module.exports, "headerBgColor", () => $20d409d918b45f60$export$d3ec0459d8f4bbed);
$parcel$export(module.exports, "teamHeaderBgColor", () => $20d409d918b45f60$export$afc7ad7e78cf1c79);
$parcel$export(module.exports, "headerBgColorDisabledUser", () => $20d409d918b45f60$export$ef73fded6fab455c);
$parcel$export(module.exports, "headerTextColor", () => $20d409d918b45f60$export$5c2df128da90e8de);
$parcel$export(module.exports, "appLabelBgColor", () => $20d409d918b45f60$export$6f79b778f6280d31);
$parcel$export(module.exports, "appLabelTextColor", () => $20d409d918b45f60$export$3db47a978b9599f9);
$parcel$export(module.exports, "labelTextColor", () => $20d409d918b45f60$export$dd73341f2a5541fa);
$parcel$export(module.exports, "labelIconColor", () => $20d409d918b45f60$export$5a20f73e634c37e3);
$parcel$export(module.exports, "errorIconColor", () => $20d409d918b45f60$export$85e73a744c5d1042);
$parcel$export(module.exports, "errorTitleColor", () => $20d409d918b45f60$export$be3c814f7ed506ed);

var $6fnsQ = parcelRequire("6fnsQ");
const $20d409d918b45f60$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`;
const $20d409d918b45f60$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $6fnsQ.B500)})`;
const $20d409d918b45f60$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $6fnsQ.N50)})`;
const $20d409d918b45f60$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $6fnsQ.N30)})`;
const $20d409d918b45f60$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`;
const $20d409d918b45f60$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $6fnsQ.N800)})`;
const $20d409d918b45f60$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $6fnsQ.N20)})`;
const $20d409d918b45f60$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $6fnsQ.N500)})`;
const $20d409d918b45f60$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $6fnsQ.N800)})`;
const $20d409d918b45f60$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $6fnsQ.N60)})`;
const $20d409d918b45f60$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $6fnsQ.N90)})`;
const $20d409d918b45f60$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $6fnsQ.N800)})`;
const $20d409d918b45f60$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $6fnsQ.N90)})`;

});


parcelRegister("bUp2E", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $4ebff2946cad2a83$export$43835e9acf248a15);
$parcel$export(module.exports, "cardTriggered", () => $4ebff2946cad2a83$export$d50ab8a3b6975c);
$parcel$export(module.exports, "teamRequestAnalytics", () => $4ebff2946cad2a83$export$c9b0e37b229a297b);
$parcel$export(module.exports, "userRequestAnalytics", () => $4ebff2946cad2a83$export$12dae48763368ac9);
$parcel$export(module.exports, "profileCardRendered", () => $4ebff2946cad2a83$export$41816a317479160b);
$parcel$export(module.exports, "actionClicked", () => $4ebff2946cad2a83$export$fdcd134fbeb1f921);
$parcel$export(module.exports, "reportingLinesClicked", () => $4ebff2946cad2a83$export$93260987012593be);
$parcel$export(module.exports, "moreActionsClicked", () => $4ebff2946cad2a83$export$79befd155063a6a7);
$parcel$export(module.exports, "teamAvatarClicked", () => $4ebff2946cad2a83$export$2703289b35687fde);
$parcel$export(module.exports, "moreMembersClicked", () => $4ebff2946cad2a83$export$b4411a7661cf2d3f);
$parcel$export(module.exports, "errorRetryClicked", () => $4ebff2946cad2a83$export$c86679da702d560e);
$parcel$export(module.exports, "agentRequestAnalytics", () => $4ebff2946cad2a83$export$a9f8c9f412cf5664);

var $caPHA = parcelRequire("caPHA");
/** Below lines are copied from teams common analytics */ const $4ebff2946cad2a83$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $4ebff2946cad2a83$var$runItLater = (cb)=>{
    const requestIdleCallback = window.requestIdleCallback;
    if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $4ebff2946cad2a83$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
    if (!createAnalyticsEvent) return;
    $4ebff2946cad2a83$var$runItLater(()=>{
        createAnalyticsEvent(body).fire($4ebff2946cad2a83$var$ANALYTICS_CHANNEL);
    });
};
/** Above lines are copied from teams common analytics */ const $4ebff2946cad2a83$var$TEAM_SUBJECT = 'teamProfileCard';
const $4ebff2946cad2a83$var$USER_SUBJECT = 'profilecard';
const $4ebff2946cad2a83$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
const $4ebff2946cad2a83$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $caPHA.getPageTime)())
        }
    });
const $4ebff2946cad2a83$var$getActionSubject = (type)=>{
    switch(type){
        case 'user':
            return $4ebff2946cad2a83$var$USER_SUBJECT;
        case 'team':
            return $4ebff2946cad2a83$var$TEAM_SUBJECT;
        case 'agent':
            return $4ebff2946cad2a83$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $4ebff2946cad2a83$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $4ebff2946cad2a83$var$createEvent('ui', 'triggered', $4ebff2946cad2a83$var$getActionSubject(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $4ebff2946cad2a83$export$c9b0e37b229a297b = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$TEAM_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$12dae48763368ac9 = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$USER_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$41816a317479160b = (type, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'rendered', $4ebff2946cad2a83$var$getActionSubject(type), actionSubjectId, attributes);
const $4ebff2946cad2a83$export$fdcd134fbeb1f921 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$getActionSubject(type), 'action', attributes);
const $4ebff2946cad2a83$export$93260987012593be = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$USER_SUBJECT, 'reportingLines', attributes);
const $4ebff2946cad2a83$export$79befd155063a6a7 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$getActionSubject(type), 'moreActions', attributes);
const $4ebff2946cad2a83$export$2703289b35687fde = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'avatar', attributes);
const $4ebff2946cad2a83$export$b4411a7661cf2d3f = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $4ebff2946cad2a83$export$c86679da702d560e = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $4ebff2946cad2a83$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);

});
parcelRegister("caPHA", function(module, exports) {

$parcel$export(module.exports, "getPageTime", () => $156cb4b98a287aa0$export$e9faea7c41053334);
const $156cb4b98a287aa0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $156cb4b98a287aa0$var$performanceAvailable = $156cb4b98a287aa0$var$isPerformanceAvailable();
const $156cb4b98a287aa0$var$initialPageTime = Date.now();
const $156cb4b98a287aa0$export$e9faea7c41053334 = ()=>{
    if ($156cb4b98a287aa0$var$performanceAvailable) return performance.now();
    return Date.now() - $156cb4b98a287aa0$var$initialPageTime;
};

});


parcelRegister("fVnHQ", function(module, exports) {

$parcel$export(module.exports, "DELAY_MS_SHOW", () => $6401e7acd2e74df8$export$5b956b542f1bc1b3);
$parcel$export(module.exports, "DELAY_MS_HIDE", () => $6401e7acd2e74df8$export$89a9f35a94d7f196);
const $6401e7acd2e74df8$export$5b956b542f1bc1b3 = 800;
const $6401e7acd2e74df8$export$89a9f35a94d7f196 = 200;

});

parcelRegister("3nj6t", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardResourced", () => $92606fc73eb2626b$export$4b013ffffcb40af8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $bUp2E = parcelRequire("bUp2E");

var $3H8bj = parcelRequire("3H8bj");

var $exN3e = parcelRequire("exN3e");

var $lFfRz = parcelRequire("lFfRz");

var $joVWg = parcelRequire("joVWg");
const $92606fc73eb2626b$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $gwFzn.useState)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [error, setError] = (0, $gwFzn.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalytics = (0, $gwFzn.useCallback)((payload)=>{
        if (createAnalyticsEvent) (0, $bUp2E.fireEvent)(createAnalyticsEvent, payload);
    }, [
        createAnalyticsEvent
    ]);
    const creatorUserId = (0, $gwFzn.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $3H8bj.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const getCreator = (0, $gwFzn.useCallback)(async (creator_type, creator)=>{
        if (!creator) return undefined;
        switch(creator_type){
            case 'SYSTEM':
                return {
                    type: 'SYSTEM'
                };
            case 'THIRD_PARTY':
                return {
                    type: 'THIRD_PARTY',
                    name: creator ?? ''
                };
            case 'CUSTOMER':
                try {
                    if (!creatorUserId || !props.cloudId) return undefined;
                    const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                    return {
                        type: 'CUSTOMER',
                        name: creatorInfo.fullName,
                        profileLink: `/people/${creatorUserId}`,
                        id: creatorUserId
                    };
                } catch (error) {
                    return undefined;
                }
            default:
                return undefined;
        }
    }, [
        creatorUserId,
        fireAnalytics,
        props.cloudId,
        props.resourceClient
    ]);
    const fetchData = (0, $gwFzn.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileData = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireAnalytics,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lFfRz.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $exN3e.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $joVWg.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        })
    });
};

});
parcelRegister("3H8bj", function(module, exports) {

$parcel$export(module.exports, "getAAIDFromARI", () => $7dc5183756e8ff90$export$3761e66a04602cbd);
const $7dc5183756e8ff90$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $7dc5183756e8ff90$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($7dc5183756e8ff90$export$470b0d72e4fdc43a, '');
};

});

parcelRegister("exN3e", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf90d0eb3671370$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eEA8O = parcelRequire("eEA8O");

var $ccHMk = parcelRequire("ccHMk");

var $7yDmn = parcelRequire("7yDmn");

var $jJfRl = parcelRequire("jJfRl");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $aHGHx = parcelRequire("aHGHx");

var $bUp2E = parcelRequire("bUp2E");
const $bcf90d0eb3671370$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $gwFzn.useEffect)(()=>{
        fireAnalytics((0, $bUp2E.profileCardRendered)('user', 'error', {
            hasRetry: hasRetry,
            errorType: errorReason
        }));
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aHGHx.ErrorTitle), {
            children: "The user is no longer available for the site"
        });
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aHGHx.ErrorTitle), {
            children: [
                "Oops, looks like we\u2019re having issues",
                /*#__PURE__*/ (0, $7UHDa.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                    color: "color.text.subtlest",
                    children: "Try again and we\u2019ll give it another shot"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $aHGHx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: "icon error",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jJfRl))),
                LEGACY_size: "xlarge"
            }),
            errorContent(),
            reload && ((0, $dh538.fg)('ptc_migrate_buttons') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                onClick: reload,
                children: "Try again"
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                appearance: "link",
                onClick: reload,
                children: "Try again"
            }))
        ]
    });
};
var $bcf90d0eb3671370$export$2e2bcd8739ae039 = $bcf90d0eb3671370$var$ErrorMessage;

});
parcelRegister("aHGHx", function(module, exports) {

$parcel$export(module.exports, "ErrorWrapper", () => $5321d44dec43675e$export$bb27b7e39840238f);
$parcel$export(module.exports, "ErrorTitle", () => $5321d44dec43675e$export$b065fd053267ec81);
$parcel$export(module.exports, "TeamErrorText", () => $5321d44dec43675e$export$90d92ccfb27352c6);
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $aCAiO = parcelRequire("aCAiO");

var $gwrgp = parcelRequire("gwrgp");
const $5321d44dec43675e$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_11c82smr _syaz1fxt _19pku2gc",
    teamErrorText: "_syaz131l _19pku2gc"
};
const $5321d44dec43675e$export$bb27b7e39840238f = (props)=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.errorWrapper),
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($5321d44dec43675e$var$ErrorWrapperLegacy, {
        "data-testId": props.testId,
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5321d44dec43675e$var$ErrorWrapperLegacy = (0, $gwrgp.default)("div", {
    target: "e1gaqn290"
})({
    textAlign: 'center',
    padding: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aCAiO.errorIconColor)
});
const $5321d44dec43675e$export$b065fd053267ec81 = (props)=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.errorTitle),
        children: props.children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($5321d44dec43675e$var$ErrorTitleLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5321d44dec43675e$var$ErrorTitleLegacy = (0, $gwrgp.default)("p", {
    target: "e1gaqn291"
})({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $aCAiO.errorTitleColor),
    margin: `${"var(--ds-space-100, 8px)"} 0`
});
const $5321d44dec43675e$export$90d92ccfb27352c6 = (props)=>(0, $dh538.fg)('compiled-migration-profilecard') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.teamErrorText),
        children: props.children
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($5321d44dec43675e$var$TeamErrorTextLegacy, {
        children: props.children
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $5321d44dec43675e$var$TeamErrorTextLegacy = (0, $gwrgp.default)("p", {
    target: "e1gaqn292"
})({
    name: "hpj8vo",
    styles: "color:var(--ds-text-subtlest, #626F86);margin-top:var(--ds-space-100, 8px);"
});

});


parcelRegister("lFfRz", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardWrapper", () => $50e0a701e5718424$export$2c6604b50c274e6f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $50e0a701e5718424$var$styles = (0, $ecnYn.xcss)({
    width: '360px'
});
const $50e0a701e5718424$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $50e0a701e5718424$var$styles,
        children: children
    });
};

});

parcelRegister("joVWg", function(module, exports) {

$parcel$export(module.exports, "AgentProfileCardLazy", () => $2d361b33fb84f723$export$ed0ca9c1d49ea0bf);

var $gwFzn = parcelRequire("gwFzn");

const $2d361b33fb84f723$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("k4Qub")));

});
parcelRegister("k4Qub", function(module, exports) {

let $e9dce4f3050dfc48$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e9dce4f3050dfc48$var$load("6FSEq"),
    $e9dce4f3050dfc48$var$load("erM4f"),
    $e9dce4f3050dfc48$var$load("gXUq7"),
    $e9dce4f3050dfc48$var$load("St9Nk"),
    $e9dce4f3050dfc48$var$load("kUAIU"),
    $e9dce4f3050dfc48$var$load("6zfzy"),
    $e9dce4f3050dfc48$var$load("cGVng")
]).then(()=>parcelRequire('iydPT'));

});



parcelRegister("j96Dd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b659668b6bbe5304$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $9hlns = parcelRequire("9hlns");

var $85wtj = parcelRequire("85wtj");

var $bUp2E = parcelRequire("bUp2E");
const $b659668b6bbe5304$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
    (0, $gwFzn.useEffect)(()=>{
        fireAnalytics((0, $bUp2E.profileCardRendered)('user', 'spinner'));
    }, [
        fireAnalytics
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $85wtj.SpinnerContainer), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {})
    });
};
var $b659668b6bbe5304$export$2e2bcd8739ae039 = $b659668b6bbe5304$var$UserLoadingState;

});



var $c13cec17a220cce8$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"5tHTv\",\"mention.1473c7d7.js\",\"kSjKH\",\"ProfileCard.5c70e623.js\",\"6zfzy\",\"modal.2203b291.js\",\"dTsOE\",\"modal.0d95ebdf.js\",\"4fCJZ\",\"modal.0e7fc71d.js\",\"kUAIU\",\"more.9db3674e.js\",\"lvR1M\",\"recent.f77a7a3a.js\",\"dUEf9\",\"location.b2899cd9.js\",\"ekztv\",\"office-building.1f9fed02.js\",\"1Y6tF\",\"main.236aeb23.js\",\"hGXAt\",\"arrow-left.ed8cca79.js\",\"cGVng\",\"AgentProfileCard.002eb038.js\",\"St9Nk\",\"AgentProfileCard.1763c88e.js\",\"c9Qqc\",\"auto-dev.998d58bd.js\",\"1TK6P\",\"auto-fix.07790e95.js\",\"grvAy\",\"auto-review.eb6c556a.js\",\"23K0q\",\"backlog-buddy.77803ebe.js\",\"3kQkj\",\"comms-crafter.37031eba.js\",\"6OXgE\",\"culture.46528ca4.js\",\"cbucA\",\"customer-insight.b71811cb.js\",\"bVhr1\",\"decision-director.cdf61897.js\",\"kE0QC\",\"feature-flag-avatar.c60bd9d5.js\",\"eVFXf\",\"generic-avatar.0faf04ac.js\",\"9FhBz\",\"hire-writer.9e73f27f.js\",\"6zB8z\",\"marketing-message-maestro.d95d5d6b.js\",\"eENGY\",\"my-user-manual.277d400f.js\",\"hmlb0\",\"okr-oracle.501b2473.js\",\"2NGxc\",\"ops-agent.6b999ec1.js\",\"bPgcq\",\"pitch-perfector.33d8fc56.js\",\"31b1q\",\"product-requirement.2b164fec.js\",\"8Lh9U\",\"release-notes.c909e5c4.js\",\"6ZzYJ\",\"research-scout.6dccd2a5.js\",\"410SS\",\"social-media-scribe.404e9147.js\",\"z3s9q\",\"team-connection.62db7c27.js\",\"9gqcE\",\"workflow-builder.48a79198.js\",\"gXUq7\",\"AgentProfileCard.dd52ab6b.js\",\"erM4f\",\"star-filled.1f795fb2.js\",\"6FSEq\",\"star.e20ad96e.js\"]"));


//# sourceMappingURL=mention.1473c7d7.js.map
